import React from 'react'
import type { DerivedMarker, DerivedTimespan } from '../types/derived_items'
import { createLinearScale, clamp } from '@utils/math'
import { useHorizontalTimelineContext } from '../context'
import { scrollerSelector } from '../selectors/scroller_selectors'
import { getScrubberDisplayData } from '../selectors/static_scrubber_display_selectors'
import { scrubberBoundsSelector, cursorSelector } from '../selectors/scrubber_display_selectors'
import { updateLeftAndRight, cancelFreeScroll } from '../actions'
import Scrubber from '../components/scrubber/Scrubber'

type ScrubberDisplayContainerProps = {
  markers: DerivedMarker[]
  timespans: DerivedTimespan[]
}

const ScrubberDisplayContainer: React.FC<ScrubberDisplayContainerProps> = props => {
  const { state, dispatch } = useHorizontalTimelineContext()

  const scrollerData = scrollerSelector(state, props)
  const { x, y, width, height } = scrubberBoundsSelector(state, props)
  const scrubberDisplayData = getScrubberDisplayData(state, props)
  const { maxWidthRatio, minWidthRatio } = scrollerData
  const handleWidth = scrubberDisplayData ? scrubberDisplayData.handleWidth : 0
  const handleHeight = scrubberDisplayData ? scrubberDisplayData.height : 0

  const surfaceWidth = width
  const surfaceHeight = height

  // TODO: We can probably move some of these calculations to the scrubber display selector
  const scale = createLinearScale([0, scrollerData.surface.width], [0, width])

  // use scroller data to calculate viewport position/size
  const viewportX = scale(Math.abs(scrollerData.surface.x))
  const viewportY = 0
  const viewportWidth = scale(scrollerData.viewport.width)
  const viewportHeight = height

  const cursors = cursorSelector(state, props)

  const newProps = {
    ...props,
    // scrubber bounds
    x,
    y,
    width,
    height,
    // cursors
    cursors,
    // surface
    surfaceWidth,
    surfaceHeight,
    // viewport
    viewportX,
    viewportY,
    viewportWidth,
    viewportHeight,
    // scroller data
    maxWidthRatio,
    minWidthRatio,
    // scrubber display data
    handleWidth,
    handleHeight,

    // callbacks
    onViewportPanStart: () => {
      dispatch(cancelFreeScroll())
    },
    onViewportPanMove: (left: number, right: number) => {
      dispatch(updateLeftAndRight(clamp(left, 0, 1), clamp(right, 0, 1)))
    },
    onViewportPanEnd: () => {},
  }

  return <Scrubber {...newProps} />
}

export default ScrubberDisplayContainer
